import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import { useTranslation } from "react-i18next";
import Footer from "../components/Footer";
import Header from '../components/Header';
const PrivacyPolicy = () => {
  const { t } = useTranslation();

  return (
    <>
    <Header/>
      <Box sx={styles.policyContainer}>
        <Typography variant="h4" sx={styles.header}>
          {t("privacy_policy_title")}
        </Typography>
            <Typography variant="body1" paragraph>
                <strong> {t("effective_date")} </strong> 4th December 2025
              </Typography>
        <Typography variant="body1" sx={styles.introText} paragraph>
          {t("privacy_policy_intro_1")}
        </Typography>

        <Typography variant="body1" sx={styles.introText} paragraph>
          {t("privacy_policy_intro_2")}
        </Typography>

        <Typography variant="body1" sx={styles.introText} paragraph>
          {t("privacy_policy_intro_3")}
        </Typography>

        <Divider sx={{ my: 3 }} />

        {/* SECTION 1 */}
        <Box sx={styles.section}>
          <Typography variant="h5" sx={styles.subHeader}>
            {t("privacy_section_1_title")}
          </Typography>

          <Typography paragraph>{t("privacy_section_1_p1")}</Typography>
          <Typography paragraph>{t("privacy_section_1_p2")}</Typography>
          <Typography paragraph>{t("privacy_section_1_p3")}</Typography>
        </Box>

        {/* SECTION 2 */}
        <Divider sx={{ my: 2 }} />
        <Box sx={styles.section}>
          <Typography variant="h5" sx={styles.subHeader}>
            {t("privacy_section_2_title")}
          </Typography>

          <Typography paragraph>{t("privacy_section_2_p1")}</Typography>
          <Typography paragraph>{t("privacy_section_2_p2")}</Typography>
          <Typography paragraph>{t("privacy_section_2_p3")}</Typography>
          <Typography paragraph>{t("privacy_section_2_p4")}</Typography>
          <Typography paragraph>{t("privacy_section_2_p5")}</Typography>
          <Typography paragraph>{t("privacy_section_2_p6")}</Typography>
          <Typography paragraph>{t("privacy_section_2_p7")}</Typography>
          <Typography paragraph>{t("privacy_section_2_p8")}</Typography>
          <Typography paragraph>{t("privacy_section_2_p9")}</Typography>
        </Box>

        {/* SECTION 3 */}
        <Divider sx={{ my: 2 }} />
        <Box sx={styles.section}>
          <Typography variant="h5" sx={styles.subHeader}>
            {t("privacy_section_3_title")}
          </Typography>

          <Typography paragraph>{t("privacy_section_3_p1")}</Typography>
          <Typography paragraph>{t("privacy_section_3_p2")}</Typography>
          <Typography paragraph>{t("privacy_section_3_p3")}</Typography>
        </Box>

        {/* SECTION 4 */}
        <Divider sx={{ my: 2 }} />
        <Box sx={styles.section}>
          <Typography variant="h5" sx={styles.subHeader}>
            {t("privacy_section_4_title")}
          </Typography>

          <Typography paragraph>{t("privacy_section_4_p1")}</Typography>
        </Box>

        {/* SECTION 5 */}
        <Divider sx={{ my: 2 }} />
        <Box sx={styles.section}>
          <Typography variant="h5" sx={styles.subHeader}>
            {t("privacy_section_5_title")}
          </Typography>
          <Typography paragraph>{t("privacy_section_5_p1")}</Typography>
          <Typography paragraph>• {t("privacy_section_5_access")}</Typography>
          <Typography paragraph>• {t("privacy_section_5_correction")}</Typography>
          <Typography paragraph>• {t("privacy_section_5_deletion")}</Typography>
          <Typography paragraph>{t("privacy_section_5_contact")}</Typography>
        </Box>

        {/* SECTION 6 */}
        <Divider sx={{ my: 2 }} />
        <Box sx={styles.section}>
          <Typography variant="h5" sx={styles.subHeader}>
            {t("privacy_section_6_title")}
          </Typography>

          <Typography paragraph>{t("privacy_section_6_p1")}</Typography>
        </Box>

        {/* SECTION 7 */}
        <Divider sx={{ my: 2 }} />
        <Box sx={styles.section}>
          <Typography variant="h5" sx={styles.subHeader}>
            {t("privacy_section_7_title")}
          </Typography>

          <Typography paragraph>{t("privacy_section_7_p1")}</Typography>
        </Box>

        {/* SECTION 8 */}
        <Divider sx={{ my: 2 }} />
        <Box sx={styles.section}>
          <Typography variant="h5" sx={styles.subHeader}>
            {t("privacy_section_8_title")}
          </Typography>

          <Typography paragraph>{t("privacy_section_8_p1")}</Typography>
        </Box>

        {/* SECTION 8 */}
        <Divider sx={{ my: 2 }} />
        <Box sx={styles.section}>
          <Typography variant="h5" sx={styles.subHeader}>
            {t("privacy_section_11_title")}
          </Typography>

          <Typography paragraph>{t("privacy_section_11_p1")}</Typography>


        </Box>

        {/* SECTION 9 */}
        <Divider sx={{ my: 2 }} />
        <Box sx={styles.section}>
          <Typography variant="h5" sx={styles.subHeader}>
            {t("privacy_sign_in_with_google_data_policy")}
          </Typography>

          <Typography paragraph>{t("privacy_consent_agreement")}</Typography>

          <Typography variant="h6" sx={styles.subHeader}>
            {t("privacy_section_google_1_title")}
          </Typography>
               <Typography paragraph>{t("privacy_collection_consent_line_1")}</Typography>
      <ul>
        <li>{t('privacy_identity_info')}</li>
        <li>{t('privacy_contact_info')}</li>
        <li>{t('privacy_profile_data')}</li>
      </ul>
      <p><em>{t('privacy_security_disclaimer')}</em></p>

                  <Typography variant="h6" sx={styles.subHeader}>
            {t("privacy_section_google_2_title")}
          </Typography>
               <Typography paragraph>{t("privacy_purpose_introduction")}</Typography>


          <Typography paragraph>{t("privacy_email_and_name_use")}</Typography>
          <Typography paragraph>{t("privacy_google_user_id_use")}</Typography>

          <Typography paragraph>{t("privacy_profile_picture_use")}</Typography>
          <Typography paragraph>{t("privacy_all_data_use")}</Typography>

         <Typography variant="h6" sx={styles.subHeader}>
            {t("privacy_section_google_3_title")}
          </Typography>
             
                       <Typography paragraph>{t("privacy_google_disclosure_line_1")}</Typography>
          <Typography paragraph>{t("privacy_google_disclosure_line_2")}</Typography>

          <Typography paragraph>{t("privacy_google_disclosure_link_label")}</Typography>
          <Typography paragraph>{t("privacy_google_policy_link_placeholder")}</Typography>
<Typography paragraph>{t("privacy_sensitive_data_consent")}</Typography>

   <Typography variant="h6" sx={styles.subHeader}>
            {t("privacy_section_google_4_title")}
          </Typography>
             
          <Typography paragraph>{t("privacy_security_practices_disclaimer")}</Typography>
          <Typography paragraph>{t("privacy_rights_consent_withdrawal")}</Typography>
               
         <Typography variant="h6" sx={styles.subHeader}>
            {t("privacy_section_google_5_title")}
          </Typography>
          <Typography paragraph>{t("privacy_grievance_officer_intro")}</Typography>

          <Typography paragraph><strong>{t("privacy_grievance_officer_name")}</strong> Saravanakumar T</Typography> 
          <Typography paragraph><strong>{t("privacy_grievance_officer_email")}</strong>support@foodsakz.com</Typography>
          <Typography paragraph><strong>{t("privacy_grievance_officer_address")}</strong>T.Nagar,Chennai</Typography>
          <Typography paragraph><strong>{t("privacy_grievance_officer_contact")}</strong>+91 999 464 1128</Typography> 



          <Typography paragraph>{t("privacy_grievance_officer_summary")}</Typography>
        </Box>
                                 
                                 
                                 
        {/* SECTION 9 */}
        <Divider sx={{ my: 2 }} />
        <Box sx={styles.section}>
          <Typography variant="h5" sx={styles.subHeader}>
            {t("privacy_section_12_title")}
          </Typography>

          <Typography paragraph>{t("privacy_section_12_p1")}</Typography>
          <Typography paragraph>{t("privacy_section_12_p2")}</Typography>
          <Typography paragraph>{t("privacy_section_12_p3")}</Typography>
  <Typography paragraph>{t("privacy_section_12_p4")}</Typography>
        </Box>

        {/* SECTION 9 */}
        <Divider sx={{ my: 2 }} />
        <Box sx={styles.section}>
          <Typography variant="h5" sx={styles.subHeader}>
            {t("privacy_section_9_title")}
          </Typography>

          <Typography paragraph>{t("privacy_section_9_p1")}</Typography>
          <Typography paragraph>{t("privacy_section_9_p2")}</Typography>
          <Typography paragraph>{t("privacy_section_9_contact_details")}</Typography>
        </Box>

        {/* SECTION 9 */}
        <Divider sx={{ my: 2 }} />
        <Box sx={styles.section}>
          <Typography variant="h5" sx={styles.subHeader}>
            {t("privacy_section_developer_title", "13. Developer")}
          </Typography>

          <Typography paragraph>Developer name : Igermitech corp</Typography>
          <Typography paragraph>Organization:IGERMITECH CORPORATION </Typography>
          <Typography paragraph>Website:https://igermitech.com/ </Typography>
             <Typography paragraph>Contact Email: info@igermitech.com </Typography>
        </Box>

      </Box>

      <Footer />
    </>
  );
};

const styles = {
  policyContainer: {
    padding: 4,
    maxWidth: 850,
    margin: "40px auto",
    backgroundColor: "#fff",
    borderRadius: 2,
    boxShadow: 3,
  },
  header: {
    color: "#00704A",
    borderBottom: "2px solid #EEE",
    paddingBottom: 1,
  },
  subHeader: {
    marginTop: 3,
    marginBottom: 1,
    fontWeight: "bold",
    color: "#333",
  },
  introText: {
    marginBottom: 2,
    fontSize: "1.05rem",
  },
  section: {
    marginBottom: 3,
  },
};

export default PrivacyPolicy;
